export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14967.13fea1d1.jpg";